import { render } from "./DSubmodel.vue?vue&type=template&id=45bc42ac&lang=pug"
import script from "./DSubmodel.vue?vue&type=script&lang=js"
export * from "./DSubmodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__